<style>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0 auto;
  left: 50%;
}

.lds-ripple div {
  position: absolute;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}

.loader-border-primary {
  border: 4px solid #5ba355;
}

.loader-border-white {
  border: 4px solid #ffffff;
}
</style>

<template>
  <div class="lds-ripple" :style="marginTopStyle">
    <div
      :class="{
        'loader-border-primary': primaryColor,
        'loader-border-white': primaryColor
      }"
    ></div>
    <div
      :class="{
        'loader-border-primary': primaryColor,
        'loader-border-white': whiteColor
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    marginTopPercentage: {
      type: String,
      default: "0"
    },
    marginTopPixels: {
      type: String,
      default: "0"
    },
    borderColor: {
      type: String,
      default: "white"
    }
  },

  computed: {
    marginTopStyle() {
      if (this.marginTopPercentage > 0) {
        return "margin-top:" + this.marginTopPercentage + "%;";
      } else {
        return "margin-top:" + this.marginTopPixels + "px;";
      }
    },

    primaryColor() {
      return this.borderColor == "primary";
    },

    whiteColor() {
      return this.borderColor == "white";
    }
  }
};
</script>
